import React, { useEffect, useState } from 'react';
import { ZapIcon } from 'lucide-react';
const TOTAL_SECONDS = 24 * 60 * 60;
function pad(value: number) {
  return value.toString().padStart(2, '0');
}
export function UrgencyBar() {
  const [secondsLeft, setSecondsLeft] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSecondsLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(secondsLeft / 3600);
  const minutes = Math.floor(secondsLeft % 3600 / 60);
  const seconds = secondsLeft % 60;
  return <div className="sticky top-0 z-50 w-full bg-navy-950 text-white" data-id="element-145" data-mp="2p4sf29qxc2ps">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-2 px-4 py-2.5 text-center sm:flex-row sm:justify-center sm:gap-4 sm:py-3" data-id="element-146" data-mp="2k6qzvzwmcnjl">
        <p className="flex items-center gap-2 text-[13px] font-semibold leading-snug sm:text-sm" data-id="element-147" data-mp="2f64fcr2t4aaw">
          <ZapIcon className="h-4 w-4 shrink-0 text-lime-400" aria-hidden="true" data-id="element-148" data-mp="2b7401ijjfpsn" />
          <span data-id="element-149" data-mp="1rw9gyys66x1g">
            <span className="text-lime-400" data-id="element-150" data-mp="1rvpz1i2is8nf">OFERTA DE LANZAMIENTO: 50% DE DESCUENTO</span>{' '}
            solo por las próximas 24 horas o hasta agotar 100 cupos.
          </span>
        </p>
        <div className="flex items-center gap-1 font-display text-sm font-bold tabular-nums" aria-label={`Quedan ${hours} horas, ${minutes} minutos y ${seconds} segundos`} data-id="element-151" data-mp="1i0fv2osk9r70">
          <span className="rounded-md bg-white/10 px-2 py-1" data-id="element-152" data-mp="2ap3lszw2x8ry">{pad(hours)}</span>
          <span className="text-white/40" data-id="element-153" data-mp="2fn525d24etzq">:</span>
          <span className="rounded-md bg-white/10 px-2 py-1" data-id="element-154" data-mp="2fksmj6ju4vpu">{pad(minutes)}</span>
          <span className="text-white/40" data-id="element-155" data-mp="21mue0hs73ti9">:</span>
          <span className="rounded-md bg-white/10 px-2 py-1" data-id="element-156" data-mp="25o656rqpwmsk">{pad(seconds)}</span>
        </div>
      </div>
    </div>;
}